var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.43328V12.2666C13.5 12.9963 12.9754 13.6239 12.2521 13.72C10.861 13.9047 9.44162 14 8 14C6.55838 14 5.13903 13.9047 3.7479 13.72C3.0246 13.6239 2.5 12.9963 2.5 12.2666V9.43327M13.5 9.43328C13.8146 9.16509 14 8.75925 14 8.32592V5.80379C14 5.08317 13.4881 4.46054 12.7754 4.35391C12.0251 4.24165 11.2663 4.15543 10.5 4.09622M13.5 9.43328C13.3709 9.54331 13.2201 9.63017 13.0514 9.68625C11.4635 10.2142 9.76516 10.5 8.00001 10.5C6.23486 10.5 4.53646 10.2142 2.94859 9.68624C2.7799 9.63016 2.62907 9.5433 2.5 9.43327M2.5 9.43327C2.18539 9.16508 2 8.75924 2 8.32591V5.80379C2 5.08317 2.51194 4.46054 3.22463 4.35391C3.97489 4.24165 4.73366 4.15544 5.5 4.09622M10.5 4.09622V3.5C10.5 2.67157 9.82843 2 9 2H7C6.17157 2 5.5 2.67157 5.5 3.5V4.09622M10.5 4.09622C9.67504 4.03247 8.84131 4 8 4C7.15869 4 6.32496 4.03247 5.5 4.09622M8 8.5H8.005V8.505H8V8.5Z",
    stroke: "#5F606D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.55c5600271015edb8c5758e053ef3c4e.svg";
export { ForwardRef as ReactComponent };